<template>
    <v-card class="flex pa-0 background-2 round-card pb-offset" v-if="!$store.getters.progress">
        <v-card-title class="pa-3">
            <p class="pl-2 pl-xl-3">Link Campagna</p>
            <v-spacer></v-spacer>
        </v-card-title>                
        <v-divider></v-divider>


        <v-data-table v-if="showTable && loaded"
            class="background-2"
            :headers="campaignLinkHeaders"
            :items="items"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0">
            <template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
                <tr class="cursor-pointer" @click="expand(!isExpanded)">
                    <template v-for="(header, h) in campaignLinkHeaders">
                        <td :key="h" style="width: 25%;">
                            {{ item[header.value] }}
                        </td>
                    </template>
                </tr>
            </template>
            <template v-slot:expanded-item="{ item, headers }">
                <tr>
                    <td :colspan="headers.length" class="px-0">                        
                        <v-card class="background-3 elevation-0">
                            <v-card-title class="pa-4">
                                <p class="pl-2 pl-xl-3" :style="{ color: $vuetify.theme.currentTheme.primary }">{{ item.link }}</p>                                <v-divider vertical class="mx-4"></v-divider>
                                <opportunity-campaign-dialog
                                    :campaignId="id"
                                    :linkId="item.id"
                                    small
                                    :button="{
                                        params: {
                                            icon: 'mdi-briefcase-plus-outline',
                                            tooltip: 'Crea Opportunità',
                                        }
                                    }"
                                ></opportunity-campaign-dialog>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on: tooltip }">
                                        <v-btn
                                        class="ml-3"
                                            @click.native.stop="$eventBusUtility.exportCSV(recipientCampaignLinkHeaders, item.campaignlink_recipient, item.link)"
                                            small
                                            icon
                                            v-on="{ ...tooltip }">
                                            <v-icon>play_for_work</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Download CSV</span>
                                </v-tooltip>
                            </v-card-title>                              
                            <v-card-text class="theme--light blue-background-1 px-6 pb-0">
                                <v-data-table
                                    :headers="recipientCampaignLinkHeaders"
                                    :items="item.campaignlink_recipient"
                                    hide-default-footer
                                    disable-pagination
                                    class="background-2 elevation-3">
                                    <template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
                                        <tr class="cursor-pointer">
                                            <template v-for="(head, hh) in recipientCampaignLinkHeaders">
                                                <td v-if="head.value == 'updated_at'" :key="hh" style="width: 25%;">
                                                    {{ item[head.value] | date }}
                                                </td>
                                                <td v-else :key="hh" style="width: 25%;">
                                                    {{ item[head.value] }}
                                                </td>
                                            </template>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <v-row class="ma-0 pa-0" justify="center">
                                    <v-col class="py-2" lg="2" md="3" sm="6">
                                        <v-list dense two-line class="background-3 w100p">
                                            <v-list-item>
                                                <v-list-item-action>
                                                    <v-icon color="primary">link</v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>Link</v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.link }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>       
                                    </v-col>
                                    <v-col class="py-2" lg="2" md="3" sm="6">
                                        <v-list dense two-line class="background-3 w100p">
                                            <v-list-item>
                                                <v-list-item-action>
                                                    <v-icon color="primary">mouse</v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>Click</v-list-item-title>
                                                    <v-list-item-subtitle>{{ item.total_clicks }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>       
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </td>
                </tr>
            </template>
            <template v-slot:footer.page-text="{ pageStart, pageStop }">
                <div class="warning--text"><span class="warning--text">{{ countSelected }}</span> Selezionati</div>
                Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
            </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-row class="pt-2 pb-2"  justify="center">
            <v-col lg="2" md="2" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="primary">link</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Link Totali</v-list-item-title>
                            <v-list-item-subtitle>{{ items.length }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>
            <v-col lg="2" md="2" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="primary">mouse</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Click Totali</v-list-item-title>
                            <v-list-item-subtitle>{{ totalClicks }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>
            <v-col lg="2" md="2" sm="6">
                <v-list two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="primary">mouse</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Click Unici</v-list-item-title>
                            <v-list-item-subtitle>{{ totalUniqueClicks }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>
        </v-row>
    </v-card>
</template>


<script>
    import OpportunityCampaignDialog from '@/components/modules/mailmarketing/OpportunityCampaignDialog'

    export default {
        name: 'campaign-links',
        components: {
            OpportunityCampaignDialog
        },
        props: {
            id: Number,
        },

        data() {
            return {
                fieldsset: {},
                campaignLinkHeaders: [
                    {
                        'text': 'Campagna',
                        'value': 'campaign'
                    },
                    {
                        'text': 'Link',
                        'value': 'link'
                    },
                    {
                        'text': 'Click Totali',
                        'value': 'total_clicks'
                    },
                    {
                        'text': 'Click Unici',
                        'value': 'unique_clicks'
                    }
                ],
                recipientCampaignLinkHeaders: [
                    {
                        'text': 'Anagrafica',
                        'value': 'business_name'
                    },
                    {
                        'text': 'Email',
                        'value': 'email'
                    },
                    {
                        'text': 'Click',
                        'value': 'click'
                    },
                    {
                        'text': 'Ultima Modifica',
                        'value': 'updated_at'
                    }
                ],
                items: [],
                showTable: true,
                loaded: false,
                loadChart: false,
            }
        },


        created() {

            this.getData()

        },

        computed: {
            totalClicks() {
                return this.items.reduce((acc, item) => {
                    return acc + item.total_clicks;
                }, 0)
            },

            totalUniqueClicks() {
                return this.items.reduce((acc, item) => {
                    return acc + item.unique_clicks;
                }, 0)
            },
        },

        methods: {

            getData() {

                this.loading = "warning"

                this.axios.post('campaignlinks-filters', {subFilters: {campaign_id: this.id}}).then(response => {
                    this.items = response.data.data
                    this.$store.commit('endProgress')
				    this.loaded = true
                    this.loading = false

                }, response => {
                    // error callback
                })
            },
        },
    }
</script>